<template>
	<div class="user-password">
		<el-form ref="form" :model="userPassword" :rules="rules">
			<el-form-item prop="oldPass" label="Current Password">
				<el-input :disabled="saving" type="password" v-model="userPassword.old_password"></el-input>
			</el-form-item>
			<el-form-item prop="newPass" label="New Password">
				<el-input :disabled="saving" type="password" v-model="userPassword.new_password"></el-input>
			</el-form-item>
			<el-form-item prop="newPassConfirm" label="New Password Confirmation">
				<el-input :disabled="saving" type="password" v-model="userPassword.new_password_confirmation"></el-input>
			</el-form-item>
		</el-form>
        <el-button class="mt-5" ref="saveUserPassword" :disabled="saving" style="width: 200px" type="primary" @click="savePassword">{{ saveText }}</el-button>
	</div>
</template>

<script>
	export default {
		name: "UserPassword",

		data() {

            var validateOldPassword = (rule, value, callback) => {
				if (!this.userPassword.old_password) {
					callback(new Error("Required"))
                } else {
					axios.post('/admin/account/validate-password', {
                        id: this.userProfile.id, 
                        password: this.userPassword.old_password
                    })
                    .then(res => {
                        if (res.data) {
                            callback()
                        } else {
                            callback(new Error("Your password is incorrect"))
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    })
				}
			}

			var validateNewPassword = (rule, value, callback) => {
				if (!this.userPassword.new_password) {
					callback(new Error("Required"))
				} else {
					if (this.userPassword.new_password_confirmation) {
						this.$refs.form.validateField("newPassConfirm")
					}
					callback()
				}
			}

			var validateNewPasswordConfirmation = (rule, value, callback) => {
				if (!this.userPassword.new_password_confirmation) {
					callback(new Error("Required"))
				} else if (this.userPassword.new_password !== this.userPassword.new_password_confirmation) {
					callback(new Error("Your passwords do not match!"))
				} else {
					callback()
				}
			}

			return {
				userPassword: {
                    old_password: '',
                    new_password: '',
                    new_password_confirmation: ''
                },
                saveText: "Change Password",
                saving: false,
                rules: {
                    oldPass: [{ required: true, validator: validateOldPassword, trigger: "blur" }],
                    newPass: [{ required: true, validator: validateNewPassword, trigger: 'blur' }],
                    newPassConfirm: [{  required: true, validator: validateNewPasswordConfirmation, trigger: 'blur' }],
                }
			}
		},

        computed: {
            userProfile() {
                return this.$store.getters['user/user']
            }
        },

		mounted() {},

		methods: {
            savePassword() {
                this.saveText = "Validating..."
                this.$refs.form.validate((valid) => {
					if (valid) {
                        this.saving = true
                        this.saveText = "Saving..."
                        let data = Object.assign({id: this.userProfile.id}, this.userPassword)
                        axios.post('/admin/account/save-user-password', data)
                        .then(response => {
                            if (response.data.success) {
                                this.$notify({
                                    title: 'Saved!',
                                    message: 'Your password was updated.'
                                });
                            } else {
                                this.$notify({
                                    title: 'Error!',
                                    message: response.data.message
                                });
                            }
                        })
                        .catch(err => {
                            this.$notify({
                                title: 'Error!',
                                message: 'There was an error while updating your password. Please contact support.'
                            });
                        })
                        .finally(() => {
                            this.saving = false
                            this.saveText = "Save Password"
                        })
                    } else {
                        this.saveText = "Save Password"
                    }
                })
            }
        },
	}
</script>

<style lang="scss" scoped>
	.user-password {
		padding: 50px;
	}
</style>